import { render, staticRenderFns } from "./successMain.vue?vue&type=template&id=1b857f84&scoped=true"
import script from "./successMain.vue?vue&type=script&lang=js"
export * from "./successMain.vue?vue&type=script&lang=js"
import style0 from "./successMain.vue?vue&type=style&index=0&id=1b857f84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b857f84",
  null
  
)

export default component.exports